(function () {
    const scriptSrc = document.currentScript.getAttribute('data-section');
    const scriptPid = document.currentScript.getAttribute('data-section-pid');
    const productCard = () => {
        var current_section = window.document.querySelector('[id$="' + scriptSrc + '"]');
        var current_product = current_section.querySelector('[data-pid$="' + scriptPid + '"]');
        var selected_color = current_product.querySelector('.product-form__item-swatch .product-color--active').getAttribute('data-color');
        var size_swatches = current_product.querySelectorAll('.size-swatch');
        toggleSizes(size_swatches, selected_color);
        size_swatches.forEach(swatch => {
            var swatch_item = swatch.querySelector('[data-variant-available=true]');
            if (swatch_item) {
                swatch.addEventListener('click', () => {
                    var variantId = swatch_item.getAttribute('data-variant');
                    var variantPrice = swatch_item.getAttribute('data-variant-price');
                    addToCart(variantId, variantPrice);
                });
            }
        });
        var color_swatches = current_product.querySelectorAll('.color-swatch');
        color_swatches.forEach( swatch => {
            swatch.addEventListener('click', () => {
                removeSelectedColor(color_swatches);
                var clicked_color = swatch.getAttribute('data-color');
                toggleSizes(size_swatches,clicked_color);
                var image_element = current_product.querySelector('.product-layout__assets img');
                toggleImages(image_element,swatch);
                swatch.classList.add('product-color--active');
            });
            // swatch.addEventListener('mouseover', () => {
            //     var image_element = current_product.querySelector('.product-layout__assets img');
            //     toggleImages(image_element,swatch);
            // });
        });

    };
    function toggleImages(image_element, color) {
        image_element.src = color.getAttribute('data-image');
    }
    function toggleSizes(size_swatches, color) {
        size_swatches.forEach(swatch => {
            if (!swatch.querySelector('[data-color-triggering="' + color + '"]') ) {
                swatch.classList.add('hide');
            } else {
                swatch.classList.remove('hide');
            }
        });
    }
    function removeSelectedColor(swatches){
        swatches.forEach( swatch => {
            swatch.classList.remove('product-color--active');
        });
    }

    function addToCart(itemId, itemPrice) {
        jQ.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: itemId
            },
            dataType: 'json',
            success: function(data) {
                jQ.ajax({
                    type: 'GET',
                    dataType: 'json',
                    url: '/cart.json',
                    success: function(cart) {
                        jQ('.navigation__item--cart-count').text(cart.item_count);
                        getCart();
                        var drawerCart = document.querySelector('#drawer-cart');
                        drawerCart.dispatchEvent(
                            new CustomEvent('product:addToCart', {
                              detail: {
                                'productID': itemId,
                                'productPrice': itemPrice
                              }
                            })
                        )

                        drawerCart.dispatchEvent(
                            new CustomEvent('product:added', {
                              detail: {
                              }
                            })
                        )
                    }
                });
            }
        });
    }

    window.addEventListener('load', function () {
        productCard();
    });
})();